import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=3d7b4864&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7b4864')) {
      api.createRecord('3d7b4864', component.options)
    } else {
      api.reload('3d7b4864', component.options)
    }
    module.hot.accept("./AdminDashboard.vue?vue&type=template&id=3d7b4864&", function () {
      api.rerender('3d7b4864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/AdminDashboard.vue"
export default component.exports